(() => {
  const params = new URLSearchParams(location.search);
  if (params.get('kind') !== 'design' || params.get('brief') !== '1') return;
  const message = document.getElementById('WiscoMessage');
  const kind = document.getElementById('WiscoKind');
  const status = document.querySelector('[data-design-handoff-status]');
  if (!message || !kind || !status) return;
  kind.value = 'design';
  kind.dispatchEvent(new Event('change', { bubbles: true }));
  const permission = document.getElementById('WiscoPhotoPermission');
  const source = document.getElementById('WiscoSource');
  if (permission) { permission.required = false; permission.disabled = true; }
  if (source) source.required = false;
  const photoRow = document.querySelector('[data-photo-permission]');
  if (photoRow) photoRow.hidden = true;
  let brief = '';
  try { brief = sessionStorage.getItem('wisco-design-brief-v1') || ''; } catch {}
  if (!message.value.trim() && brief) message.value = brief.slice(0, 3000);
  status.textContent = message.value.trim() ? status.dataset.ready : status.dataset.missing;
})();
